//
//
//
//

export default {
    name: "order-all"
}



// WEBPACK FOOTER //
// ./src/components/order/OrderAll.vue